/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsExportAodRulesQueryResponse, AuditReportsExportAodRulesQueryParams, AuditReportsExportAodRules401, AuditReportsExportAodRules403 } from "../models/AuditReportsExportAodRules";

export function getAuditReportsExportAodRulesUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-rules/export` as const }
  return res
}

/**
 * @summary Export AOD rules (csv, xls, json)
 * {@link /audit-reports/v1/aod-rules/export}
 */
export async function auditReportsExportAodRules(params: AuditReportsExportAodRulesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsExportAodRulesQueryResponse, ResponseErrorConfig<AuditReportsExportAodRules401 | AuditReportsExportAodRules403>, unknown>({ method : "GET", url : getAuditReportsExportAodRulesUrl().url.toString(), params, ... requestConfig })
  return res.data
}